import logo from './logo.svg';
import './App.css';
import { Paymybill } from './components/Paymybill';
import Grid from '@mui/material/Grid';

function App() {
  return (
    <div className="App">
      <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: '70vh' }}
      >
      <Grid item xs={3}>
      
      
          <div className="content">
            <Paymybill/>
            
          </div>
      
      </Grid>
    </Grid>
    </div>
  );
}

export default App;
